import React, { useEffect, useState } from 'react';
import api from '../../api';

const PERIODS = [
  { value: '7d', label: 'Last 7 days' },
  { value: 'week', label: 'This week' },
  { value: 'month', label: 'This month' },
];

export default function LangCountryActivity() {
  const [period, setPeriod] = useState('7d');
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function loadActivity() {
      try {
        const { data } = await api.get('/admin/metrics/lang-country/activity', {
          params: { period },
        });

        if (!ignore) {
          setResult({ period, attempt, data, error: '' });
        }
      } catch (error) {
        if (!ignore) {
          setResult({
            period,
            attempt,
            data: null,
            error:
              error?.response?.data?.error ||
              'Failed to load country activity.',
          });
        }
      }
    }

    loadActivity();

    return () => {
      ignore = true;
    };
  }, [period, attempt]);

  const currentResult =
    result?.period === period && result.attempt === attempt ? result : null;
  const data = currentResult?.data;
  const countries = data?.countries ?? [];

  function changePeriod(event) {
    setPeriod(event.target.value);
    setResult(null);
  }

  return (
    <section className="langcountry-activity" aria-labelledby="country-activity-title">
      <h3 id="country-activity-title">Activity by saved country</h3>

      <div className="langcountry-activity-controls">
        <label htmlFor="country-activity-period">Period</label>{' '}
        <select
          id="country-activity-period"
          value={period}
          onChange={changePeriod}
        >
          {PERIODS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {!currentResult && (
        <p className="langcountry-loading" role="status">
          Loading country activity…
        </p>
      )}

      {currentResult?.error && (
        <div className="langcountry-error">
          <p role="alert">{currentResult.error}</p>
          <button type="button" onClick={() => setAttempt((value) => value + 1)}>
            Retry
          </button>
        </div>
      )}

      {data && (
        <>
          <p>{data.startDate} to {data.endDate} ({data.timezone}, inclusive)</p>
          <p>
            {data.summary.activeUsers.toLocaleString()} users with recorded activity
          </p>

          {data.summary.unmatchedActivityUsernames > 0 && (
            <p>
              {data.summary.unmatchedActivityUsernames.toLocaleString()} recorded
              usernames had no matching profile.
            </p>
          )}

          {countries.length === 0 ? (
            <p>No country rows are available.</p>
          ) : (
            <>
              {data.summary.activeUsers === 0 && (
                <p>No matching users recorded activity in this period.</p>
              )}


<div
  className="langcountry-activity-table"
  role="region"
  aria-label="Country activity rankings"
  tabIndex={0}
>

                <table aria-labelledby="country-activity-title">
                  <thead>
                    <tr>
                      <th scope="col">Country</th>
                      <th scope="col">Active users</th>
                      <th scope="col">Registered users</th>
                      <th scope="col">Active rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {countries.map((country) => (
                      <tr key={country.countryCode ?? 'unknown'}>
                        <th scope="row">{country.name}</th>
                        <td>{country.activeUsers.toLocaleString()}</td>
                        <td>{country.registeredUsers.toLocaleString()}</td>
                        <td>{country.activeRatePct.toFixed(2)}%</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>
      )}
    </section>
  );
}
